// To be kept in sync with https://git.hubteam.com/HubSpot/IdentityBase/blob/78bca99dcb5fd8b64d630dca01a74842afdbf17e/src/main/protobuf/contacts.proto#L267
// (link is to commit as of 08/08/2024, check file at latest master for updates)
export const ABSOLUTE = 'absolute';
export const ABSOLUTE_WITH_RELATIVE = 'absolute_with_relative';
export const TIME_SINCE = 'time_since';
export const TIME_UNTIL = 'time_until';